import { IBEError } from '@common/interfaces/be-error.interface';
import { ICollection } from '@common/interfaces/collection.interface';
import { createCollection } from '@common/utils/create-collection.util';
import { itemApiRequest, TItemV1ItemGetError } from '@src/api/item-generated-api';
import { ICachedProductCatalogItemDto } from '@src/api/model/cached-product-catalog-item.dto';
import { createExclusionDto, IExclusionDto } from '@src/api/model/exclusion.dto';
import { queryClient } from '@src/shared/query-client';
import { useQuery, UseQueryResult } from 'react-query';

const NAME = 'exclusions';
const useGetExclusions = (): UseQueryResult<ICollection<IExclusionDto>, IBEError<TItemV1ItemGetError>> => {
    return useQuery<ICollection<IExclusionDto>, IBEError<TItemV1ItemGetError>>(`${NAME}-list`, () => {
        return itemApiRequest
            .itemV1ExclusionGet({ limit: 1000 })
            .then((r) => createCollection(r.data.exclusion_list?.map((e) => createExclusionDto(e)) || [], 0, {}));
    });
};

const getExclusionsFromCache = (): ICollection<ICachedProductCatalogItemDto> | undefined => {
    return queryClient.getQueryData(`${NAME}-list`);
};

export const exclusions = {
    useGetExclusions,
    getExclusionsFromCache,
};
